export enum RequiredProvidedLookup {
  Country = 1,
  IRB = 2,
  DataRoom = 3,
  InvestigativeSite = 4,
}

export enum RequiredDocumentAssociation {
  allSites = 'allSites', //All Investigative Sites
  invSite = 'investigativeSiteId',
  country = 'country',
  irb = 'irbId',
  general = 'general', //requiredBy and providedBy = dataroom
}

export enum Processes {
  Ssu = 1,
  Etmf = 2,
  RegPack = 3,
  Amendment = 4,
  EventDriven = 5,
}

export enum RequiredDocsLogActions {
  Update = 1,
  Create = 2,
  Remove = 3,
}

export enum HistoryLogTypes {
  formFields = 1,
  docType = 4,
  defaultValues = 5,
  keywordLookup = 6,
  requiredDocuments = 7,
}

export enum TriggerCriteria {
  Completed = 0,
  Immediately = 1,
}
